function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFF1D6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}, React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#FFAB00"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#a)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 52.54V49.4c0-3.45-2.823-6.276-6.276-6.276H12.276C8.823 43.125 6 45.948 6 49.401v3.138a29.138 29.138 0 0018.498 6.592A29.163 29.163 0 0043 52.539z",
  fill: "#E7E3E7"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 52.54V49.4c0-3.45-2.823-6.276-6.276-6.276H27.36l-.493.312 1.747 5.394-1.135 10.145A29.118 29.118 0 0043 52.54zm-37 0V49.4c0-3.45 2.823-6.276 6.276-6.276h9.364l.493.312-1.747 5.394 1.135 10.145A29.128 29.128 0 016 52.54z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.091 47.208l.526 1.623-1.135 10.145a29.054 29.054 0 003.512-.573l2.292-4.428-2.797-8.84c-.867.246-1.673 1.007-2.398 2.073z",
  fill: "#30295E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 28.371c2.784 0 5.063 2.28 5.063 5.064v9.693c0 2.785-2.279 5.064-5.063 5.064-2.785 0-5.064-2.28-5.064-5.064v-9.693a5.077 5.077 0 015.064-5.064z",
  fill: "#E9BAA8"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 28.371c2.784 0 5.063 2.28 5.063 5.064v8.311a10.217 10.217 0 01-4.362.978c-2.122 0-4.101-.654-5.762-1.771v-7.518a5.072 5.072 0 015.06-5.064zm-13.388-1.498a3.22 3.22 0 003.138 3.305c.05 0 .101.003.149 0-.327-1.153-.505-2.31-.505-3.412v-.983c.003-2.021-2.702-1.887-2.782 1.09zm26.772 0a3.223 3.223 0 01-3.138 3.305c-.05 0-.101.003-.149 0 .327-1.153.505-2.31.505-3.412v-.983c-.002-2.021 2.705-1.887 2.782 1.09z",
  fill: "#D58881"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 8.17c-5.83 0-10.603 4.93-10.603 10.956v9.967c0 6.027 4.772 10.957 10.603 10.957 5.83 0 10.602-4.93 10.602-10.957v-9.967C35.101 13.1 30.332 8.17 24.502 8.17z",
  fill: "#E9BAA8"
}), React.createElement("path", {
  opacity: 0.6,
  d: "M24.138 28.749s.054.136.144.305c.043.081.091.178.145.28l.073.151c.018.052.045.1.057.148.021.049.027.094.04.14.002.041.011.087.008.126-.006.04-.003.084-.02.12-.013.04-.022.085-.046.118-.024.037-.036.079-.06.109s-.043.057-.06.081l-.055.082s.033-.003.096-.012c.03-.006.07-.012.112-.027a.58.58 0 00.136-.07c.024-.015.051-.03.076-.051.024-.024.045-.048.069-.075.051-.052.078-.124.109-.2.018-.039.018-.078.024-.117.003-.04.012-.085.006-.124a.761.761 0 00-.049-.236 1.045 1.045 0 00-.096-.202c-.036-.063-.082-.118-.124-.169a1.174 1.174 0 00-.271-.232c-.17-.115-.314-.145-.314-.145z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M20.899 22.28a.78.78 0 00.664-.347c.097-.15-.01-.522-.226-.688-.622-.48-2.672-.232-4.033.546-.616.354-1.304 1.353-1.304 1.356a1.4 1.4 0 01.145-.076l.172-.081a12.001 12.001 0 011.053-.45c.296-.109.601-.196.912-.248.866-.148 1.748-.012 2.617-.012zm.456 4.211c.009.178-.01.347-.046.504-.117-.543-.458-.933-.848-.918-.347.013-.628.348-.74.813a1.888 1.888 0 01-.042-.326c-.033-.704.317-1.29.782-1.31.462-.025.867.53.894 1.237zm6.055-4.211a.781.781 0 01-.665-.347c-.096-.15.01-.522.227-.688.622-.48 2.671-.232 4.032.546.616.354 1.305 1.353 1.305 1.356a1.343 1.343 0 00-.145-.076l-.173-.081a12.001 12.001 0 00-1.053-.45 5.03 5.03 0 00-.911-.248c-.867-.148-1.748-.015-2.617-.012zm-.456 4.211c-.01.178.009.347.045.504.118-.543.459-.933.848-.918.348.013.628.348.74.813.021-.106.04-.212.042-.326.033-.704-.317-1.29-.782-1.31-.461-.025-.866.53-.893 1.237z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  d: "M23.111 36.78s.154-.002.36.007c.102.003.22.006.34.015.124.003.251.012.378.012a7.77 7.77 0 00.549-.006c.058 0 .112-.003.16-.006.049-.006.097-.006.142-.006.042-.006.079-.006.112-.01l.102-.002s-.024.03-.069.078a.926.926 0 01-.214.17.9.9 0 01-.16.084 1.49 1.49 0 01-.63.118 1.601 1.601 0 01-.78-.212 1.08 1.08 0 01-.29-.241z",
  fill: "#DB9C94"
}), React.createElement("path", {
  d: "M27.95 31.435c-.347-.169-2.152.592-3.906.595-1.681.003-3.314-.755-3.643-.595-1.02.495 1.289 5.02 3.875 4.869 2.584.15 4.694-4.377 3.674-4.869z",
  fill: "#7A2742"
}), React.createElement("path", {
  d: "M27.497 31.447c.003.266-.027.667-.205.912-.284.392-1.02 1.391-4.027 1.177-2.405-.172-2.656-1.57-2.659-2.125.555.033 1.992.619 3.465.616 1.334-.003 2.696-.444 3.426-.58z",
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.528 24.47s-1.424.032-1.424 1.31c0 0-1.004-1.317-.796-2.966 0 0-2.72-3.17-2.594-6.713.122-3.542 2.882-4.3 2.882-4.3 6.618 1.935 1.932 6.624 1.932 12.668zm-24.053 0s1.424.032 1.424 1.31c0 0 1.004-1.317.796-2.966 0 0 2.719-3.17 2.594-6.713-.125-3.542-2.882-4.3-2.882-4.3-6.621 1.935-1.932 6.624-1.932 12.668z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.183 5.498a6.266 6.266 0 019.176 5.551 6.266 6.266 0 01-10.56 4.565 3.794 3.794 0 01-3.373 2.05 3.784 3.784 0 01-2.779-1.21 3.801 3.801 0 01-6.443-.5A5.44 5.44 0 0115.439 5.22a5.33 5.33 0 011.682.267 6.205 6.205 0 015.533-3.402 6.181 6.181 0 015.53 3.414z",
  fill: "#0E1A3C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 48.189l3.578 3.432s1.322.773 1.848-.35c.523-1.124 2.122-8.146 2.122-8.146l-2.485-.92c-.003.002-.14 4.347-5.063 5.984z",
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.563 44.81a.141.141 0 01.208.19c-.003.003-1.272 1.335-1.272 4.526v6.562c-.095.047-.19.092-.282.14v-6.702c0-3.301 1.343-4.71 1.346-4.716z",
  fill: "#1C1341"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.909 47.208l-.526 1.623 1.135 10.145a29.059 29.059 0 01-3.513-.573l-2.294-4.428 2.797-8.84c.87.246 1.676 1.007 2.4 2.073z",
  fill: "#30295E"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.502 48.189l-3.578 3.432s-1.326.773-1.849-.35c-.526-1.124-2.122-8.146-2.122-8.146l2.485-.92c0 .002.137 4.347 5.064 5.984z",
  fill: "#fff"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.437 44.81a.141.141 0 00-.208.19c.003.003 1.274 1.335 1.274 4.526v6.562l.283.14v-6.702c0-3.301-1.346-4.71-1.35-4.716z",
  fill: "#1C1341"
}));

var SvgDontSmileImg = function SvgDontSmileImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDontSmileImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dont-smile-img.c8a6bcdd.svg";
export { ForwardRef as ReactComponent };